import React from "react";
import { withTheme } from "styled-components";
import Image from "next/image";

import {
  Container,
  FormContainer,
  ScheduleSection,
  ScheduleSectionContainer,
  ScheduleSummary,
  BtnWrap,
  CustomButton,
} from "./styled";
import { useWindowDimensions } from "../../../hooks";
import { IsDesktop, IsPad } from "../../../components/ResponsiveContainers";
import ScheduleForm from "../../ContactUs/ScheduleForm";
import IsMobile from "../../../components/ResponsiveContainers/IsNotMobile";

const Banner = ({ theme }) => {
  const { isMobile } = useWindowDimensions();
  const imgPath = !isMobile
    ? "/images/closets/banner_closets.jpg"
    : "/images/home_page/banner_mobile.jpg";

  return (
    <Container>
      <Image
        alt="closets banner"
        src={imgPath}
        layout="fill"
        objectFit="cover"
        loading="lazy"
        quality={100}
      />
      <IsDesktop>
        <FormContainer>
          <ScheduleForm />
        </FormContainer>
      </IsDesktop>
      <IsPad>
        <ScheduleSectionContainer>
          <ScheduleSection>
            <ScheduleSummary>
              Schedule a FREE in-home consultation today!
            </ScheduleSummary>
            <BtnWrap>
              <CustomButton
                ptype="primary"
                pname="GET STARTED"
                width="100%"
                bgColor={theme.colors.prune}
                hoverBgColor={theme.colors.hoverColor2}
                shadow="yes"
              />
            </BtnWrap>
          </ScheduleSection>
        </ScheduleSectionContainer>
      </IsPad>
    </Container>
  );
};

export default withTheme(Banner);
